import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/wayhood/wayhood.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/wayhood/WayhoodOfficialShell.tsx");
